import { RootState } from "@/store/store";
import { cloudChiprApi } from "@/services/cloudchipr.api";
import { getAzureSavingsPlansForDataGridFixedCacheKey } from "@/store/commitments/thunks/azure/saving-plans/getAzureSavingsPlansForDataGridThunk";

export const azureSavingsPlansForTableSelector = (state: RootState) => {
  return cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentAzureSavingsPlans.select(
    getAzureSavingsPlansForDataGridFixedCacheKey,
  )(state);
};
